import { useEffect, useMemo, useState } from "react";
import ReactTooltip from "react-tooltip"; // TOOLTIP POSITIONING ENGINE!: popper.js.org
import InfoIconWithTooltip from "../../UI/InfoIconWithTooltip/InfoIconWithTooltip";

import styles from "./EvaluateChecklistRow.module.css";
import srdStles from "../../sharedStyles/QuestionsListPagesRow.module.css";

const qntAnswerTypes = [
  { value: "na", name: "N/A" },
  { value: "qv", name: "Numeric Values" } // qv = quantitative values
]

const EvaluateChecklistRow = (props) => {
  const [displayButtons, setDisplayButtons] = useState(false);
  // const [selectedQuantOpScopeAnswer, setSelectedQuantOpScopeAnswer] = useState(props.opScopes);
  const [quantOpScopes, setQuantOpScopes] = useState(props.questionType === 'quantitative' ? JSON.parse(JSON.stringify(props.opScopes)) : "");
  const [note, setNote] = useState(props.note);

  const [qntAnswerType, setQntAnswerType] = useState();

  const [opScopesVisibility, setOpScopesVisibility] = useState();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isInfoIconVisible, setIsInfoIconVisible] = useState(false);
  // const [isInfoTextVisible, setIsInfoTextVisible] = useState(false);
  const qualitativeAnswers = useMemo(() => props.qualitativeAnswers, []);

  useEffect(() => {
    setNote(props.note);
    if (props.questionType === "quantitative") {
      setQuantOpScopes(JSON.parse(JSON.stringify(props.opScopes)));
    }
    if (props.ambitoType && props.ambitoType === "quantitative") {
      console.log("props.selectedAnswerType: ", props.selectedAnswerType)
      setQntAnswerType(qntAnswerTypes.filter(type => type.value === props.selectedAnswerType)[0].name);
    }
    if (props.questionType && (props.questionType === "qualitative")) {
      const opScopesVisibilityArray = props.opScopes.map(_ => false);
      setOpScopesVisibility(opScopesVisibilityArray)
    }
  }, [props]);

  let tooltipText = props.tooltip;
  if (props.ambitoType === "quantitative") {
    const quantitativeQstInstructions = "Note: Select the type of value for the quantitative operational areas using the dropdown.\nWarning: By choosing 'N/A', all the numeric values will be removed."
    tooltipText = tooltipText ? `${tooltipText} \n${quantitativeQstInstructions}` : quantitativeQstInstructions;
  }

  const showElementButtons = (e) => {
    e.preventDefault();
    setDisplayButtons(true);
  };

  const hideElementButtons = (e) => {
    e.preventDefault();
    setDisplayButtons(false);
  };

  const showInfoIcon = (e) => {
    e.preventDefault();
    setIsInfoIconVisible(true);
  };

  const hideInfoIcon = (e) => {
    e.preventDefault();
    setIsInfoIconVisible(false);
  };

  // console.log("ROW rerendred")

  // console.log("opScopesVisibilityArray: ", props.questionType && opScopesVisibility);  
  const changeQualitativeAnswersVisibility = (index) => {
    // 
    const updatedData = [...opScopesVisibility];
    let item = updatedData[index];
    if (opScopesVisibility[index] === false) {
      item = true;
      setIsDropdownVisible(true);
    }
    else {
      item = false;
      setIsDropdownVisible(false);
    };
    updatedData[index] = item;
    setOpScopesVisibility(updatedData);
  }

  const closeBackdropHandler = () => {
    const newData = [...opScopesVisibility].map(_ => false);
    setOpScopesVisibility(newData);
    setIsDropdownVisible(false);
  }

  const updateQuestion = (pos, opScope, qualAnswer) => {
    setIsDropdownVisible(false);
    props.updateQuestionAnswer(pos, opScope, qualAnswer);
  }

  const quantInputHandler = (e, scopeName) => {
    let updatedValue = e.target.value;

    updatedValue = updatedValue.replace(/\D/g, '');
    console.log('updatedValue', updatedValue);
    const updatedScopes = JSON.parse(JSON.stringify(quantOpScopes))
    for (const scope of updatedScopes) {
      if (scope.name === scopeName) {
        scope.answer = updatedValue;
        break;
      }
    }
    setQuantOpScopes(updatedScopes);
    // setSelectedQuantOpScopeAnswer(e.target.value);
  }

  const updateQuantQuestionHandler = (scopeName) => {
    for (const scope of quantOpScopes) {
      if (scope.name === scopeName) {
        console.log('current answer: ', scope.answer)
        props.updateQuestionAnswer(pos, scope, scope.answer)
      }
    }
  }

  const changedQntAmbitoAnswerType = (event, pos) => {
    const updatedValue = event.target.value;
    console.log("updatedValue: ", updatedValue)
    props.changedQuantitativeAmbitoAnswerType(pos, updatedValue);
  }

  let title = props.title;
  let titleStyle = "";
  let type = props.type;
  let pos = props.pos; // position/index of row in the array
  if (type === "principio") titleStyle = styles.principio;
  else if (type === "requisito") titleStyle = styles.requisito;
  else if (type === "ambito") titleStyle = styles.ambito;

  const determineAnswerType = (answerType) => {
    switch (answerType) {
      case "Good":
        return "good"
      case "Satisfactory":
        return "satisfactory"
      case "Unsatisfactory":
        return "unsatisfactory"
      case "Poor":
        return "poor"
      case "N/A":
        return "n_a"
      default:
    }
  }

  let qualitativeQuestionAnswers = props.questionType && props.questionType === "qualitative" &&
    props.opScopes.map((opScope, opScopeIndex) => {
      return opScope.enabled ? (
        <td key={pos + "-|-" + opScope.name} className={`${styles.opScopeWidth} ${styles.tdWidth}`}>
          {/* {console.log(pos + "-|-" + opScope.name)} */}
          <div id="list1" className={`${styles.dropdownCheckList} smallItalic`}>
            {opScope.answer ? <button
              className={`${styles.qualAnswerButton} ${styles[determineAnswerType(opScope.answer)]} nexiColor`}
              onClick={() => { changeQualitativeAnswersVisibility(opScopeIndex) }}
            >
              {opScope.answer}
            </button>
              : <button
                className={`${styles.qualAnswerButtonNoSelection} nexiColor`}
                onClick={() => { changeQualitativeAnswersVisibility(opScopeIndex) }}
              >
                Select Answer
              </button>}
            <ul
              className={`${styles.items} ${opScopesVisibility && opScopesVisibility[opScopeIndex] && isDropdownVisible ? "visible" : "invisible"} overflow-visible`}
            >
              {qualitativeAnswers.map((qualAnswer, index) => {
                const answerType = determineAnswerType(qualAnswer);
                return (
                  <li key={qualAnswer + '-' + pos + '-' + opScope.name}>
                    {/* {console.log("qualAnswer + index + opScope.name: ", qualAnswer + '-' + pos + '-' + opScope.name)} */}
                    <button className={`${styles[answerType]}`} onClick={() => { updateQuestion(pos, opScope, qualAnswer) }}>{qualAnswer}</button>
                  </li>
                );
              })}
            </ul>
          </div>
        </td>
      ) : <td className={`${styles.disabledTd} ${styles.opScopeWidth}`}>N/A</td>
    });

  const elementDropdownArrow = (
    <div
      className={`${srdStles.dropdownArrowContainer} overflow-visible p-0`}
    >
      <button
        onClick={
          () => {
            props.collapseElement(pos, !props.isCollapsed)
          }
        }
        className={`${srdStles.dropdownArrow} ${props.isCollapsed ? srdStles.down : srdStles.up} ${displayButtons ? "visible" : "invisible"}`}
      ></button>
    </div>
  );

  const quantitativeAnswerTypeDropdown = (
    <div
      className={`${styles.qntAnswerTypeDropdownContainer} ${isInfoIconVisible ? 'visible' : 'invisible'}`}>
      {/* <Select
        data={qntAnswerTypes}
        selectedValue={"qv"}
        reducedFontSize={true}
        onChange={(event) =>
          changedQntAmbitoAnswerType(event, pos)
        }
      /> */}
      <select
        className={`${styles.select} nexiColor fw-bold w-100 mw-50`}
        defaultValue={props.selectedAnswerType ? props.selectedAnswerType : "qv"}
        onChange={(event) =>
          changedQntAmbitoAnswerType(event, pos)}
        onClick={e => { e.stopPropagation() }}>
        {qntAnswerTypes.map((el, index) => (
          // selected={(selectedValue === el.value) ? true : false}
          <option
            key={index}
            className={`${styles.option} 
            ${el.value !== 0 && " fw-bold"} textColor`}
            value={el.value}
          // selected={selectedValue === el.value ? true : false}
          >

            {el.name}
          </option>
        ))}
      </select>
    </div>
  )

  return (
    <tr
      className={`${titleStyle} ${!type && styles.trHover}`}
      onMouseEnter={(e) => {
        showElementButtons(e);
        showInfoIcon(e);
      }}
      onMouseLeave={(e) => {
        hideElementButtons(e);
        hideInfoIcon(e);
      }}
    >
      {/* TITLE*/}
      <td
        className={`
          ${type && "text-white"} ${styles.questionsWidth} 
          ${type && (srdStles.cursorPointer + ' ' + srdStles[`${type}Hover`])} 
          ${props.isCollapsed && srdStles[`${type}Valid`]}
          ${/*props.isCollapsed && (props.hasValidChildren ? srdStles[`${type}Valid`] : srdStles[`${type}Invalid`]) */""}
          fw-bold text-start position-relative px-2
        `}
        data-tip=""
        colSpan={!type ? 1 : props.opScopesList.length + 1}
        onClick={() => {
          if (type) {
            props.collapseElement(pos, !props.isCollapsed);
          }
        }}
      >
        {/* backdrop */}
        <div
          className={`${styles.backdrop} ${isDropdownVisible ? "visible" : "invisible"
            }`}
          onClick={closeBackdropHandler}
        ></div>
        {type && elementDropdownArrow /* excluding ambiti because they have the plus button */}
        {!type ? (
          <div className="d-flex">
            {props.questionType !== "quantitative" ? (
              <div className={`${styles.questionId} ${styles.qltQstDisplayId} pe-2 me-2`}>{props.principioId}.{props.displayId && props.displayId}</div>
            ) : null}
            <textarea defaultValue={title} disabled className={`fw-bold m-0`} />
          </div>
          // <p className={`${styles.qstParagraph} m-0`} style={{ maxHeight: "80px", overflowX: "hidden", overflowY: "auto"}}>{title}</p>
        ) : (
          <p className={`m-0 mb-2`}
            style={
              type === "requisito"
                ? { paddingLeft: "7px" }
                : type === "ambito"
                  ? { paddingLeft: "14px" }
                  : {}
            }
          >
            {title}
          </p>
        )}

        {/* Tooltip */}
        {type === "ambito" && props.ambitoType === "quantitative" && quantitativeAnswerTypeDropdown}
        {type === "ambito" && props.ambitoType === "quantitative" && <div className={`${styles.quantAnswerTypeIndicator} ${!isInfoIconVisible ? "visible" : "invisible"}`}>{qntAnswerType}</div>}
        <InfoIconWithTooltip text={tooltipText}  show={isInfoIconVisible} />
      </td>
      {/* EMPTY CELLS FOR NON-QUESTION ELEMENTS (currently replaced with colSpan on the title td) */}
      {/* {type && props.osKeys.map( (osScope, index) => (
        <td className={`${styles.opScopeWidth}`} key={pos + osScope}>
        </td>
      ))} */}
      {/* QUALITATIVE ANSWERS */}
      {qualitativeQuestionAnswers}
      {/* QUANTITATIVE ANSWERS */}
      {!type &&
        props.questionType === "quantitative" &&
        quantOpScopes.map((el) => {
          // let opScopeIndex = props.opScopes.findIndex(scope => scope.name === el.name)
          // let inputValue = props.opScopes[opScopeIndex].answer;
          return el.enabled ? (
            <td
              className={`${styles.opScopeWidth} ${styles.tdWidth}`}
              key={type + "-" + pos + "-" + el.name}
            >
              <input
                className={`${styles.inputNumberField} ${styles.noSpinner}`}
                disabled={el.answer === "N/A"}
                type="text"
                // defaultValue={el.answer}
                value={el.answer}
                onChange={(e) => quantInputHandler(e, el.name)}
                onBlur={() => updateQuantQuestionHandler(el.name)}
              />
            </td>
          ) : (
            <td className={styles.disabledTd}>N/A</td>
          );
        })}
      {/* NOTE */}
      <td className={`${!type && styles.note} ${styles.notesWidth}`}>
        {!type && (
          <textarea
            className={`fw-bold`}
            value={note ? note : ""}
            onChange={(e) => {
              setNote(e.target.value);
            }}
            onBlur={() => {
              props.updateNote(pos, note);
            }}
          />
        )}
        {type && ""}
      </td>
    </tr>
  );
};

export default EvaluateChecklistRow;
